import { RouteRecordRaw } from "vue-router";

export default {
  path: "/control",
  name: "ControlPage",
  component: () => import("@/views/control/ControlPage.vue"),
  meta: {
    title: "播出控制",
    hideMenu: true,
  },
} as RouteRecordRaw;
